// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style_arrow__JlLNA","below-the-fold":"style_below-the-fold__xPQiB"};